<script lang="ts">
    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    import { _ } from 'svelte-i18n';

    import type { ZoneType } from './types';
    import IconRemove from '../../shared/Icons/IconRemove.svelte';
    import InputText from '../../shared/InputText.svelte';
    import SelectVehicle from '../Vehicles/SelectVehicle.svelte';
    import type { VehicleResponseType } from '../Vehicles/types';
    import StyleLikeFilterItem from '../../shared/StyleLikeFilterItem.svelte';
    import { debug, tacticalPlanRuleCurrent, tacticalPlanStore } from '../../../stores/store';
    import CustomColorPicker from '../../shared/CustomColorPicker.svelte';
    import InputTextInline from '../../shared/InputTextInline.svelte';
    import { waitForZoneSave } from '../TacticalPlan/waitForZoneSave';
    import type { TacticalPlanRule } from '../TacticalPlan/TacticalPlanRule';
    import ModalConfirm from '../../shared/Modals/ModalConfirm.svelte';
    import { openModal } from 'svelte-modals';
    import ModalRemoveSomething from '../Modals/ModalRemoveSomething.svelte';
    import IconRemoveFilter from '../../shared/Icons/IconRemoveFilter.svelte';

    // https://coloris.js.org/
    // https://www.npmjs.com/package/@melloware/coloris
    // import "@melloware/coloris/dist/coloris.css";
    // import Coloris from "@melloware/coloris";
    // import * as Color from "@melloware/coloris";

    export let vehicle_id: number | null = null;
    export let vehicles: VehicleResponseType[] = [];
    export let readOnly: boolean = false;
    export let alreadyUsedVehicles: number[] = [];
    export let rule: TacticalPlanRule;
    export let onChangeVehicle: (vehicle_id: number | null) => void;
</script>

<div class="zone-item zone-item-data zone-id-null">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="vehicle" style="display: flex;">
        <StyleLikeFilterItem mode="standard">
            <div
                style="display: flex; column-gap: 6px; align-items: center; padding: 0 0 0 6px;"
                on:click={() => {
                    if (readOnly) {
                        waitForZoneSave(() => {
                            readOnly = false;
                            $tacticalPlanRuleCurrent = rule.getInnerId();
                        });
                    }
                }}
            >
                <CustomColorPicker color="#ffffff" disabled={true} onChange={() => {}} />
                <div class="zone-name">
                    <InputTextInline
                        value={$_('without_zone')}
                        disabled={true}
                        editMode={false}
                        showEditIcon={false}
                        styleMode="italic"
                        onChange={v => {}}
                    />
                </div>
                <StyleLikeFilterItem mode="vehicle">
                    <SelectVehicle
                        disabled={readOnly}
                        selected={vehicle_id}
                        {vehicles}
                        {alreadyUsedVehicles}
                        onChange={selected => {
                            $tacticalPlanRuleCurrent = rule.getInnerId();
                            alreadyUsedVehicles = alreadyUsedVehicles.filter(v => v !== vehicle_id);
                            if (selected !== null) {
                                alreadyUsedVehicles.push(selected);
                                alreadyUsedVehicles = alreadyUsedVehicles;
                            }
                            console.log('alreadyUsedVehicles, SelectVehicle', alreadyUsedVehicles);
                            vehicle_id = selected;
                            // put vehicle
                            // onChangeZone(zone);
                            onChangeVehicle(selected);
                            return true;
                        }}
                    />
                </StyleLikeFilterItem>
            </div>
        </StyleLikeFilterItem>
    </div>
    <div style="display: flex; align-items: center;"></div>
</div>

<style>
    .vehicle {
        position: relative;
    }
    .zone-item {
        padding-right: 10px;
    }
    .zone-name {
        width: 133px;
    }
</style>
